import React, { forwardRef } from 'react';
import { Help as AkHelp, type HelpProps } from '@atlaskit/atlassian-navigation';
import {
	SkeletonHelpButton,
	Nav4SkeletonHelpButton,
} from '@atlaskit/atlassian-navigation/skeleton-help-button';
import { getWillShowNav4 } from '@atlassian/jira-navigation-apps-sidebar-nav4-rollout-core/src/common/utils/get-will-show-nav4/index.tsx';
import { Help as Nav4Help } from '@atlassian/navigation-system';
import { expVal } from '@atlassian/jira-feature-experiments';

// Should this live in the migration layer (@atlassian/jira-navigation-system) instead?
export const Help = forwardRef<HTMLButtonElement, HelpProps>((props, ref) => {
	if (!expVal('blu-6875-nav4-perf-help-button', 'cohort', false) && __SERVER__) {
		if (getWillShowNav4()) {
			// @ts-expect-error - Type 'ReactNode' is not assignable to type 'string'.
			return <Nav4SkeletonHelpButton label={props.tooltip} />;
		}
		// @ts-expect-error - Type 'ReactNode' is not assignable to type 'string'.
		return <SkeletonHelpButton label={props.tooltip} />;
	}

	if (getWillShowNav4()) {
		const { badge, onClick, isSelected, label } = props;
		return (
			<Nav4Help badge={badge} label={label} onClick={onClick} isSelected={isSelected} ref={ref} />
		);
	}
	const buttonProps = { ...props, ref };
	return <AkHelp {...buttonProps} />;
});
